<template>
  <div class="reform-warpper">
    <div class="bg-white">
      <staticChiose @SearchInfo="SearchInfo"/>
      <div class="reform-box flex align-center margin-top-sm">
        <div class="reform-left">
          <img src="../../assets/img/reform-icon.png" alt="">
          <h3>新增同意改造调查情况</h3>
        </div>
        <div class="flex align-center justify-around reform-right">
          <div>
            <p>总户数</p>
            <h3>{{ GZZongHuShu }}</h3>
          </div>
          <div>
            <p>同意改造户数</p>
            <h3>{{ GZXinZengTongYiShu }}</h3>
          </div>
          <div>
            <p>增长</p>
            <h3>{{ GZXinZengTongYiLv }}%</h3>
          </div>
          <div>
            <p>通过率</p>
            <h3>{{ GZHeJiTongYiLv }}%</h3>
          </div>
        </div>
      </div>
      <div class="reform-box active flex align-center margin-top-sm">
        <div class="reform-left">
          <img src="../../assets/img/mj.png" alt="" width="44px">
          <h3>新增同意综改房屋面积统计</h3>
        </div>
        <div class="flex align-center justify-around reform-right">
          <div>
            <p>房屋总面积</p>
            <h3>{{ GZZongMianJi }}m²</h3>
          </div>
          <div>
            <p>同意改造房屋面积</p>
            <h3>{{ GZXinZengMianJiTongYiShu }}m²</h3>
          </div>
          <div>
            <p>增长</p>
            <h3>{{ GZXinZengMianJiTongYiLv }}%</h3>
          </div>
          <div>
            <p>占比</p>
            <h3>{{ GZHeJiMianJiTongYiLv }}%</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white margin-top-sm">
      <journal />
    </div>
  </div>
</template>

<script>
import journal from '@/components/journal'
import staticChiose from '@/components/static-chiose'
import {zhDate} from "@/utils/utils";
import { zongHeGaiZaoTongJi} from "@/api/statistics";
export default {
  name: "synthesize-reform",
  data() {
    return {
      GZHeJiTongYiLv: 0,
      GZXinZengTongYiLv: 0,
      GZXinZengTongYiShu: 0,
      GZZongHuShu: 0,
      GZHeJiMianJiTongYiLv : 0,
      GZXinZengMianJiTongYiLv: 0,
      GZZongMianJi: 0,
      GZXinZengMianJiTongYiShu: 0,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "综合改造", false);
  },
  components: {
    staticChiose,
    journal
  },
  methods: {
    async SearchInfo(val) {
      let _data = await zongHeGaiZaoTongJi(
          1,
          val.dateArr ? zhDate(val.dateArr[0]) + ' 00:00:00' : '',
          val.dateArr ? zhDate(val.dateArr[1]) + ' 23:59:59': '',
          val.project,
          val.community
      )
      this.GZHeJiTongYiLv = (_data.data.GZHeJiTongYiLv*100).toFixed(2)
      this.GZXinZengTongYiLv = (_data.data.GZXinZengTongYiLv *100).toFixed(2)
      this.GZXinZengTongYiShu = _data.data.GZXinZengTongYiShu
      this.GZZongHuShu = _data.data.GZZongHuShu

      this.GZHeJiMianJiTongYiLv = (_data.data.GZHeJiMianJiTongYiLv*100).toFixed(2)
      this.GZXinZengMianJiTongYiLv = (_data.data.GZXinZengMianJiTongYiLv *100).toFixed(2)
      this.GZZongMianJi = _data.data.GZZongMianJi
      this.GZXinZengMianJiTongYiShu = _data.data.GZXinZengMianJiTongYiShu
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.reform-warpper{
  .reform-box{
    width: 100%;
    height: 162px;
    padding: 20px 0;
    border-radius: 8px;
    background: url(../../assets/img/reform-bg.png) no-repeat;
    background-size: 100% 100%;
    &.active{
      background: url(../../assets/img/reform-bg2.png) no-repeat;
      background-size: 100% 100%;
    }
    .reform-left{
      width: 320px;
      height: 129px;
      padding: 20px 0;
      border-right: 1px solid #fff;
      img{
        display: block;
        margin: 0 auto 15px;
      }
      h3{
        text-align: center;
        color: #fff;
        font-size: 20px;
      }
    }
    .reform-right{
      flex: 1;
      color: #fff;
      p{
        font-size: 16px;
        line-height: 24px;
      }
      h3{
        font-size: 35px;
        line-height: 45px;
      }
    }
  }
}
</style>
